import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { environment } from '@environment/environment';
import { TcDaviviendaComponent } from './tc-davivienda/tc-davivienda.component';

const routes: Routes = [
  {
    path: '',
    component: TcDaviviendaComponent,
    data: {
        meta: {
            robots: environment.statusMetaGeneric
        }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class TcDaviviendaRoutes {};
